import { useEffect } from "react"
import { useContext, useState } from "react"
import { useParams } from "react-router-dom"
import { Context } from "../../../../../utils/context"

const useKYCDetailsModal = ({open}) => {

    const { axios, authData, permissions } = useContext(Context)
    const authToken = `Bearer ${authData.token}`

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState()

    const [kyc, setKYC] = useState([])
    const [selected, setSelected] = useState()

    const params = useParams()
    const cardholderID = params?.id

    useEffect(() => {
        if(authData && open) actions.onInitModule() 
    }, [authData, open])


    const actions = {
        onInitModule: async() => {
            console.log('Request data', authData)
            setLoading(true)
            try {
                axios.defaults.headers.common['Authorization'] = authToken
                const response = await axios.get(`/kyc/${cardholderID}`)
                console.log(response.data.data)
                if(response.data.data){
                    setKYC(response.data.data)
                }else{
                    setKYC([])
                }
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        },
        onSelectedItem: (_data) => {
            if(_data?.idTran === selected?.idTran){
                setSelected(null)
            }else{
                setSelected(_data)
            }
            
        }
    }

    const data = {cardholderID, kyc, selected}
    const system = {loading, error}
    return {data, actions, system}

}

export default useKYCDetailsModal